import { Outlet } from "react-router";
import '@/global.css'

export default function AuthLayout() {
    return (
        <div className="flex h-screen w-screen bg-background-white">
            <Outlet/>
        </div>
    )
}